module.exports = __webpack_public_path__ + "img/number-2.8c87b6aa.png";